import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    color: ${cssTheme.default.day.text};
    cursor: pointer;
  `,

  detailsMobile: css`
    padding: ${spacing(2)};
  `,
  arrowIcon: css`
    justify-self: flex-end;
    [dir='rtl'] & {
      transform: rotate(180deg);
    }
  `,
  paper: css`
    border-radius: 24px;
    overflow: hidden;
    width: 320px;
    padding: 16px;
  `,
  closeIcon: css`
    display: none;
  `,
  title: css`
    font-size: 24px;
    font-weight: 700;
    line-height: 27px;
  `,
}
